import React, { useState } from "react";
import ReactDOM from "react-dom";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { getAlerts, throwAlertById } from "../services/alertServices";
import HandleUIError from "../utils/HandleUIError";
import { CButton } from "@coreui/react";
import { RxDragHandleDots2 } from "react-icons/rx";
import axiosConfig from "../services/axiosConfig";
import { useAppSelector } from "../redux/hooks";
import UsePermission from "../hooks/usePermission";
import confirmationDialog from "./toast-dialogs/ConfirmationDialog";
import { useHistory } from "react-router-dom";
import toast from "react-hot-toast";
import { createActivityReq } from "../services/activityLogService";
import { getButtonStyle } from "../helpers/uiTransforms";


// fake data generator
const getItems = (count, offset = 0) =>
    Array.from({ length: count }, (v, k) => k).map(k => ({
        id: `item-${k + offset}-${new Date().getTime()}`,
        content: `item ${k + offset}`
    }));

const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};



/**
 * Moves an item from one list to another list.
 */
const move = (source, destination, droppableSource, droppableDestination) => {
    const sourceClone = Array.from(source);
    const destClone = Array.from(destination);
    const [removed] = sourceClone.splice(droppableSource.index, 1);
    destClone.splice(droppableDestination.index, 0, removed);
    const result = {};
    result[droppableSource.droppableId] = sourceClone;
    result[droppableDestination.droppableId] = destClone;
    return result;
};
const grid = 8;



const getListStyle = isDraggingOver => ({
    // background: isDraggingOver ? "lightblue" : "lightgrey",
    padding: grid,
    width: "100%"
});



const DragAndDrop = () => {
    const [state, setState] = useState([]);


    const { checkPermission } = UsePermission()
    const history = useHistory();

    const organizationId = useAppSelector(
        (state) => state.UserSlice.user.organizationId
    );
    const userId = useAppSelector((state) => state.UserSlice.user.id);



    React.useEffect(function () {
        getAlerts()
            .then((response) => {
                setState(response.data);
            })
            .catch((e) => {
                HandleUIError(e);
            });
    }, []);

    async function onDragEnd(result) {
        const { source, destination } = result;

        if (!destination) return; // agar drop outside hai to kuch mat karo

        if (source.index !== destination.index) {
            // Pehle state ko update kar do (Optimistic UI)
            const items = reorder(state, source.index, destination.index);
            setState(items);

            // Backend ke liye payload prepare karo
            const payload = items.map((item, index) => ({
                id: item.id,
                orderby: index + 1,
                organization_id: organizationId,
            }));

            try {
                await axiosConfig.post('/admin/alerts-types/reorder', { order: payload });
            } catch (err) {
                console.error('Failed to reorder:', err);
                // Optionally rollback state agar request fail ho:
                // setState(previousState);
            }
        }
    }


    const getItemStyle = (isDragging, draggableStyle = {}, color = "grey") => ({
        userSelect: "none",
        padding: grid,
        margin: `0 0 ${grid}px 0`,
        width: 400,
        background: isDragging ? color : color, // <- yahan dynamic color
        ...draggableStyle,
    });

    function onPressSendAlert(itemType, itemId) {
        const confirmationDialogOptions = {
            title: `Are you sure you want to send this alert? (${itemType})`,
            confirmAction: () => {
                onPressThrowAlert(itemId).catch((e) => console.warn(e));
            },
        };
        confirmationDialog(confirmationDialogOptions);
    }

    async function onPressThrowAlert(alertTypeId) {
        try {
            await throwAlertById(alertTypeId, userId);
            history.push("/");
            // window.location.reload();
            toast.success("Alert thrown successfully");
            await createActivityReq('Quick Alert Send Successfully')
        } catch (e) {
            HandleUIError(e);
        }
    }


    return (

        <>
            <div className="alert-container alert-card">
                <div className="buttons-alerts-container">
                    <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId="alertList">
                            {(provided, snapshot) => (
                                <div
                                    ref={provided.innerRef}
                                    style={getListStyle(snapshot.isDraggingOver)}
                                    {...provided.droppableProps}
                                >
                                    {state.map((item, index) => (
                                        <Draggable
                                            key={String(item.id)}
                                            draggableId={String(item.id)}
                                            index={index}
                                        >
                                            {(provided, snapshot) => (
                                                <div
                                                    style={getItemStyle(
                                                        snapshot.isDragging,
                                                        provided.draggableProps?.style,
                                                        item?.color

                                                    )}
                                                    className="overflow-hidden rounded-pill text-center"
                                                    onClick={() => {
                                                        checkPermission('Send Quick Alert') && onPressSendAlert(item.name, item.id)
                                                    }}
                                                >
                                                    <div className="position-relative"
                                                        style={getButtonStyle(item.color)}
                                                    >

                                                        {/* <img src={item.icon} alt={item.name} style={{ width: 30, height: 30 }} /> */}
                                                        <span>{item.name}</span>

                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            className="position-absolute end-0 pe-2 top-0 h-100 d-flex align-items-center"
                                                        >
                                                            <RxDragHandleDots2
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )}


                                        </Draggable>
                                    ))}
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>

                    </DragDropContext>

                </div>
            </div >

        </>
    );
}
export default DragAndDrop;
